export const SW_INIT = "SW_INIT";
export const SET_MENU = "SET_MENU";
export const SET_TABLE = "SET_TABLE";
export const SW_UPDATE = "SW_UPDATE";
export const SET_ERRORS = "SET_ERRORS";
export const SET_MINI_MENU = "SET_MINI_MENU";
export const SET_FROM_LOGIN = "SET_FROM_LOGIN";
export const SET_TRIGGER_TABLE = "SET_TRIGGER_TABLE";
